import * as React from 'react';
import { observer } from 'mobx-react';

import SocketContext from '../SocketContext';
import ChannelReactions from '../ChannelReactions';
import ChannelAvailabilityStore from '../ChannelAvailabilityStore';

interface Props {
  name: string;
  channelAvailabilityStore: ChannelAvailabilityStore;
}

const UpcomingSessionsChannel: React.FC<Props> = ({ name, channelAvailabilityStore }) => (
  <SocketContext.Consumer>
    {(details) => (
      <ChannelReactions
        store={details.socketStore}
        availabilityStore={channelAvailabilityStore}
        name={name}
        fireImmediately={true}
      />
    )}
  </SocketContext.Consumer>
);

export default observer(UpcomingSessionsChannel);
